export const Cursor = {
  INITIAL_CURSOR_REFERENCE: 'START',
  FINAL_CURSOR_REFERENCE: 'END'
};